<div class="container anim-loading" *appAdminPermission="['ViewContract'];">
  <div class="page-title page-title--columns">
    <div class="page-title__left">
      <h2 i18n>Contratos</h2>
    </div>
    <div class="page-title__right" *appAdminPermission="['CreateContract'];">
      <button i18n type="button" class="btn btn-fade-primary"
        title="Cadastrar novo contrato"
        (click)="openCreateOrUpdateContract()">Novo Contrato</button>
    </div>
  </div>
  <div class="mb-4">
    <form [formGroup]="searchForm" (submit)="handleSearch()">
      <div class="row no-gutters">
        <div class="col-11">
          <div class="form-group">
            <input type="text" class="form-control form-search"
              formControlName="search" i18n-placeholder
              placeholder="Buscar registro" (ngModelChange)="searchKey($event)"
              autocomplete="off">
          </div>
        </div>
        <div class="col-1">
          <div class="filter-dropdown filter-dropdown--md">
            <button type="button"
              class="btn btn-outline-secondary btn-icon filter-dropdown__handle"
              i18n><i
                class="material-icons">filter_alt</i> Filtrar</button>

            <div class="filter-dropdown__content">
              <div class="row">
                <div class="col-6 mt-1">
                  <app-input type="multiselect" [list]="companies"
                    label="Empresas" formControlName="companyId"
                    selectText="name" selectValue="id" placeholder="Todos"
                    i18n-placeholder i18n-label>
                  </app-input>
                </div>
                <div class="col-6">
                  <label i18n>Status:</label>
                  <select type="text" tabindex="4" class="form-control"
                    formControlName="status" placeholder="Selecione o status">
                    <option i18n value disabled selected>Selecione o
                      status</option>
                    <option i18n value="all">Todos</option>
                    <option i18n value="enabled">Ativo</option>
                    <option i18n value="closed">Fechado</option>
                    <option i18n value="test">Em Teste</option>
                    <option i18n value="expired">Vencido</option>
                    <option i18n value="history">Histórico</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-5 col-5 mt-1">
                  <label class="mt-1" i18n>Periodo Vigência:</label>
                  <input type="date" class="form-control"
                    formControlName="startsAt">
                </div>
                <div class="col-md-1 col-1 aling-filter-period-2">
                  <label i18n>à</label>
                </div>
                <div class="col-md-5 col-5 aling-filter-period">
                  <input type="date" class="form-control mb-5"
                    formControlName="endsAt">
                </div>
              </div>
              <div class="mt-2 filter-dropdown__footer">
                <button i18n type="submit" class="btn btn-info btn-block"
                  (click)="handleSearch()"
                  data-dismiss="modal" ng-disabled="!isValid">Aplicar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="loading-page" *ngIf="loading">
    <div class="loading-spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
  <app-enum-i18n [input]="module"
    (output)="setModuleI18n($event)"></app-enum-i18n>

  <div class="table-responsive table-hover table-block" *ngIf="!loading">

    <table class="table bg-white">
      <thead class="bg-header-table">
        <tr>
          <th i18n class="text-center">Status</th>
          <th i18n class>Contrato</th>
          <th i18n class="text-center">Empresas</th>
          <th i18n class="text-center">Ambientes</th>
          <th i18n class="text-center" *ngIf="user.superUser || gb.isOn('ECS-5791')">Interface</th>
          <th i18n class="text-center">Módulos</th>
          <th i18n class="text-center">Periodo Vigência</th>
          <th i18n class="text-center"
            *appAdminPermission="['CreateContract'];">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let contract of contracts">
          <td class="text-center" (click)="openContractView(contract)"
            [ngSwitch]="contract?.status">
            <span *ngSwitchCase="'expired'" class="badge"
              style="background-color: #FF0000; color: #FFFFFF"
              i18n>Vencido</span>
            <span *ngSwitchCase="'closed'" class="badge"
              style="background-color: #808080; color: #FFFFFF"
              i18n>Fechado</span>
            <span *ngSwitchCase="'enabled'" class="badge"
              style="background-color: #008000; color: #FFFFFF"
              i18n>Ativo</span>
            <span *ngSwitchCase="'test'" class="badge"
              style="background-color: #FFFF00; color: #000000"
              i18n>Em Teste</span>
            <span *ngSwitchCase="'history'" class="badge"
              style="background-color: #0000FF; color: #FFFFFF"
              i18n>Histórico</span>
            <span *ngSwitchDefault class="badge badge-fade-secondary">{{
              contract?.status }}</span>
          </td>
          <td (click)="openContractView(contract)">
            {{contract?.code + '-' + contract?.name}}
            <p style="color: #999; font-size: 11px;"
              *ngIf="contract?.internalCode">
              Código Interno: {{contract?.internalCode}}
            </p>
          </td>
          <td class="text-center" (click)="openContractView(contract)">
            <div class="badge badge-secondary mr-1">
              <strong
                appTooltip="Empresa reponsável pelo contrato">{{contract?.company?.name
                || getCompanyName(contract?.ownerCompanyId)}}</strong>
            </div>
            <div *ngFor="let company of contract.companies"
              class="badge badge-secondary mr-1">
              <span
                *ngIf="company?.name !== contract?.company?.name && company?.name !== getCompanyName(contract?.ownerCompanyId)">
                {{company?.name}}
              </span>
            </div>
          </td>
          <td class="text-center" (click)="openContractView(contract)">
            <span *ngIf="contract?.enabled?.ecs"
              class="badge badge-secondary mr-1" i18n>
              eCS
            </span>
            <span *ngIf="contract?.enabled?.bequest"
              class="badge badge-secondary mr-1" i18n>
              Legado
            </span>
          </td>
          <td class="text-center" *ngIf="user.superUser || gb.isOn('ECS-5791')">
            <div class="custom-control custom-switch mt-2"
              *ngIf="contract?.enabled?.ecs">
              <div class="content table-caption">
                <div class="form-group">
                  <label class="custom-control-label"
                    [ngClass]="{checked:contract.enabled.omnia}">
                    Omnia
                    <input type="checkbox"
                      class="form-control custom-control-input"
                      [(ngModel)]="contract.enabled.omnia"
                      (change)="updateContractEdit(contract)">
                  </label>
                </div>
                <div class="form-group">
                  <label class="custom-control-label"
                    [ngClass]="{checked:contract.enabled.initus}">
                    Initus
                    <input type="checkbox"
                      class="form-control custom-control-input"
                      [(ngModel)]="contract.enabled.initus"
                      (change)="updateContractEdit(contract)">
                  </label>
                </div>
                <div class="form-group">
                  <label class="custom-control-label"
                    [ngClass]="{checked:contract.enabled.initusTraffic}">
                    Initus Traffic
                    <input type="checkbox"
                      class="form-control custom-control-input"
                      [(ngModel)]="contract.enabled.initusTraffic"
                      (change)="updateContractEdit(contract)">
                  </label>
                </div>
              </div>
            </div>
          </td>
          <td class="text-center" (click)="openContractView(contract)">
            <div *ngIf="contract?.modules?.length > 0;">
              <span *ngFor="let module of contract.modules.slice(0,3)"
                class="badge badge-secondary mr-1" i18n>
                {{ getModuleI18n(module) }}
              </span>
              <a *ngIf="contract?.modules?.length > 3"
                class="badge badge-secondary">...</a>
            </div>
          </td>
          <td class="text-center" style="white-space: nowrap" (click)="openContractView(contract)">
            <p *ngIf="contract?.startsAt" i18n>{{ contract?.startsAt | moment:
              'L LTS' }} a<br /> {{ contract?.endsAt | moment: 'L LTS' }}</p>
          </td>
          <td class="text-center"
            *appAdminPermission="['UpdateContract'];">
            <button type="button" class="btn text-secondary btn-icon-block"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="material-icons">more_horiz</i>
            </button>
            <div class="dropdown-menu" aria-labelledby="btnGroupDrop4">
              <a class="dropdown-item"
                (click)="openCreateOrUpdateContract(contract)" i18n>
                Editar Contrato
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <app-pagination
    (items)="setContracts($event)"
    [params]="params"
    [deleteEvent]="deleteEvent"
    [service]="contractService"
    [sortFn]="expiredFirstSort"
    (clear)="contracts=[]">
  </app-pagination>
</div>
